export default "__VITE_ASSET__CBeMRRDg__"